export const downloadCSV = (content: any, filename: string) => {
  if (document && window) {
    // Add UTF-8 BOM for Excel to properly render language-specific characters
    const UTF8_BOM = '\uFEFF';
    const contentWithBOM = content ? UTF8_BOM + content : content;
    const downloadUrl = window.URL.createObjectURL(new Blob([contentWithBOM]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } else {
    console.error('Document HTML object or window object does not exist!');
  }
};
